import { Component } from '@angular/core';

@Component({
  selector: 'app-score-info',
  templateUrl: './score-info.component.html',
  styleUrl: './score-info.component.css'
})
export class ScoreInfoComponent {

}
